// extracted by mini-css-extract-plugin
export default {"root":"NotFoundBlock_root__Lu6fg","content":"NotFoundBlock_content__B9GF4","description":"NotFoundBlock_description__bXsdq"};